import React, { ReactNode } from 'react';
import { StatusTypes } from '@dashboard-experience/utils';
import PanelComponent from './PanelComponent';

export interface PanelProps {
  children?: ReactNode;
  className?: string;
  'data-testid'?: string;
  i18n?: boolean;
  icon?: string;
  noBlock?: boolean;
  statusType?: string;
  status?: string;
  secondaryStatus?: string | null;
  enableAssessmentLabel?: boolean;
  timestamp?: string;
  title?: string | ReactNode;
  tooltip?: string | ReactNode;
}

const Panel: React.FC<PanelProps> = ({
  children,
  className = '',
  'data-testid': dataTestId = 'panel',
  i18n = false,
  icon = '',
  noBlock = false,
  statusType = StatusTypes.Legacy,
  status = '',
  secondaryStatus = null,
  timestamp = '',
  title = '',
  tooltip = '',
}) => {
  return (
    <PanelComponent
      {...{
        children,
        className,
        dataTestId,
        i18n,
        icon,
        noBlock,
        statusType,
        status,
        secondaryStatus,
        timestamp,
        title,
        tooltip,
      }}
    />
  );
};

export default Panel;
